import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Button,
  Alert
} from '@mui/material';
import CaptchaModal from '../components/common/CaptchaModal';
import SimpleSliderCaptcha from '../components/common/SimpleSliderCaptcha';

const CaptchaTest = () => {
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [message, setMessage] = useState('');
  const [modalOpen, setModalOpen] = useState(false);

  const handleCaptchaVerify = () => {
    setCaptchaVerified(true);
    setMessage('验证码验证成功！');
    setModalOpen(false);
  };

  const handleCaptchaReset = () => {
    setCaptchaVerified(false);
    setMessage('');
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleTest = () => {
    if (captchaVerified) {
      setMessage('测试通过！验证码功能正常工作。');
    } else {
      setMessage('请先完成验证码验证。');
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center">
        验证码测试页面
      </Typography>
      
      <Card sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            滑块验证码测试
          </Typography>
          
          <Box sx={{ mb: 3 }}>
            <SimpleSliderCaptcha
              onVerify={handleCaptchaVerify}
              onReset={handleCaptchaReset}
              width={300}
              height={125}
            />
          </Box>

          {message && (
            <Alert 
              severity={captchaVerified ? "success" : "info"} 
              sx={{ mb: 2 }}
            >
              {message}
            </Alert>
          )}

          <Box sx={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              onClick={handleTest}
              disabled={!captchaVerified}
              size="large"
            >
              {captchaVerified ? '测试通过' : '请先完成验证'}
            </Button>
          </Box>
        </CardContent>
      </Card>

      <Box sx={{ mt: 4, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
        <Typography variant="h6" gutterBottom>
          测试说明
        </Typography>
        <Typography variant="body2" paragraph>
          1. 拖动滑块到目标位置完成验证
        </Typography>
        <Typography variant="body2" paragraph>
          2. 验证成功后可以点击"测试通过"按钮
        </Typography>
        <Typography variant="body2" paragraph>
          3. 点击刷新按钮可以重新生成验证码
        </Typography>
        <Typography variant="body2">
          4. 验证码图片随机从大学logo中选取
        </Typography>
      </Box>
    </Container>
  );
};

export default CaptchaTest;
